import { render } from "./OcrConfirmation.vue?vue&type=template&id=7579db9a&scoped=true"
import script from "./OcrConfirmation.vue?vue&type=script&lang=js"
export * from "./OcrConfirmation.vue?vue&type=script&lang=js"

import "./OcrConfirmation.vue?vue&type=style&index=0&id=7579db9a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7579db9a"]])

export default __exports__